/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ContactTypeEnum {
    ALTERNATE = 'Alternate',
    EMERGENCY = 'Emergency',
    LANDLORD = 'Landlord',
    SPOUSE = 'Spouse',
}